export default __webpack_public_path__ + "static/ax-7f90fe54564eb5e88460f9ad72c9dd45.svg";